import React, { useState } from "react";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../app/slice/authSlice";
import UserRoles from "../enums/UserRoles.ENUM";
import { getAuthProps } from "../utils/authentication/authLibrary";
import { useMenu } from "../context/MenuContext";
import ThemeSidebar from "./ThemeSidebar.js";
import PropTypes from "prop-types";

import "./Header.scss";
import { encryptUrlData } from "../utils/encryption/CryptoService";

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authData = getAuthProps();
  const organizationId = authData?.organizationId;
  const userRoleId = authData?.roles?.roleId;

  const { showAdminMenu, toggleAdminMenu } = useMenu();

  const [themeSidebarVisible, setThemeSidebarVisible] = useState(false);

  const handleAdminMenuToggle = () => {
    toggleAdminMenu();
    const navPath = !showAdminMenu ? `/organization-details/${encryptUrlData(organizationId)}` : "/";
    navigate(navPath);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="header-container">
      <div className="left-section">
        <button
          type="button"
          className="pi pi-bars toggle-bar"
          style={{ marginLeft: "auto", cursor: "pointer", background: 'none', border: 'none' }}
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
        </button>
      </div>
      <div className="middle-section"></div>
      <div className="right-section">
        <div className="btn-section">
          <span className="btn-container">
            <Button
              outlined
              as={Link}
              to="/settings"
              tooltip="Interviews"
              data-pr-position="bottom"
              icon="pi pi-calendar"
            />
            {userRoleId === UserRoles.ADMIN && (
              <Button
                // onClick={toggleAdminMenu}
                onClick={handleAdminMenuToggle}
                outlined
                tooltip={showAdminMenu ? "Home" : "Administration"}
                data-pr-position="bottom"
                icon={showAdminMenu ? "pi pi-home" : "pi pi-cog"}
                key={showAdminMenu ? "admin" : "home"}
              />
            )}
            <Button
              outlined
              as={Link}
              to="#"
              tooltip="Themes"
              data-pr-position="bottom"
              icon="pi pi-th-large"
              onClick={() => setThemeSidebarVisible(true)}
            />

            <ThemeSidebar
              visible={themeSidebarVisible}
              onHide={() => setThemeSidebarVisible(false)}
            />
            <span className="user-menu">
              <Button
                outlined
                as={Link}
                to="/settings"
                // tooltip="User" data-pr-position="bottom"
                icon="pi pi-user"
              ></Button>
              <div className="dropdown">
                <ul>
                  <li>Profile</li>
                  <li>Notifications</li>
                  <li className="logout" onClick={handleLogout}>
                    <span>Logout</span>
                  </li>
                </ul>
              </div>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
};

export default Header;
